import buttonStyle from "assets/jss/material-dashboard-pro-react/components/utils/buttonStyle";

const utilsStyle = (theme) => ({
  ...buttonStyle,
});

export default utilsStyle;
